module.exports = __webpack_public_path__ + "../resources/images/illustration_to_me-6c234a96a0600294b60b18d73ba04bbb.svg";